import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollAnimation<HTMLElement>();
  const { ref: imageRef, isVisible: imageVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.2 });
  const { ref: statsRef, isVisible: statsVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.3 });

  return (
    <section id="quem-somos" className="py-24 bg-white" ref={sectionRef}>
      <div className="w-full px-6">
        <div className="max-w-[90%] mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className={`transition-all duration-1000 ${sectionVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`}>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Gestão <span className="text-[#D4AF37]">Inteligente</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                A <strong>Persona Pro</strong> é uma empresa líder no setor de terceirização de serviços e recursos humanos, dedicada a fornecer soluções excepcionais para empresas de todos os tamanhos. Com uma visão inovadora e um compromisso firme com a excelência, a Persona Pro se destaca como parceira estratégica para otimizar processos, impulsionar eficiência e promover o crescimento sustentável.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Na Persona Pro, a qualidade é a nossa marca registrada. Nossos serviços de terceirização são projetados para atender às necessidades específicas de cada cliente, proporcionando uma abordagem personalizada e adaptável. Investimos em treinamento contínuo e tecnologia de ponta para garantir padrões elevados em todas as etapas da terceirização.
              </p>
              <div 
                ref={statsRef}
                className={`mt-10 grid grid-cols-3 gap-8 transition-all duration-1000 delay-300 ${statsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              >
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#D4AF37] mb-2">500+</div>
                  <div className="text-sm text-gray-600">Empresas Atendidas</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#D4AF37] mb-2">2000+</div>
                  <div className="text-sm text-gray-600">Profissionais Contratados</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-[#D4AF37] mb-2">98%</div>
                  <div className="text-sm text-gray-600">Satisfação dos Clientes</div>
                </div>
              </div>
            </div>
            
            <div 
              ref={imageRef}
              className={`relative transition-all duration-1000 delay-200 ${imageVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'}`}
            >
              <div className="w-full h-[500px] rounded-lg overflow-hidden shadow-2xl">
                <img 
                  src="https://static.readdy.ai/image/d1ac1a7e8ecb2076670ea669c1984b4f/c819064ea0c14b48d28c0bd98c2b2d55.jpeg"
                  alt="Equipe Persona Pro"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#D4AF37] rounded-lg -z-10"></div>
              <div className="absolute -top-6 -left-6 w-32 h-32 border-4 border-[#D4AF37] rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
